






























import { Prop, Component, Vue } from 'vue-property-decorator'
import { TriggeredAction } from '@/api/model/triggered-action'
import { TriggeredActionAPI } from '@/api/backend-client'

@Component
export default class TriggeredActionDetail extends Vue {
    @Prop({ required: true }) readonly triggeredActionId!: string
    triggeredAction: TriggeredAction = null
    loading: boolean = false

    async mounted() {
        this.loading = true
        await this.loadTriggeredAction()
        this.loading = false
    }

    async loadTriggeredAction(): Promise<void> {
        this.triggeredAction = await TriggeredActionAPI.get(this.triggeredActionId, true)
    }

    async goBackToLister(): Promise<void> {
        await this.$router.push({
            name: 'company_settings_virtual_colleague_triggered_action',
        })
    }
}
